import { createFileRoute } from '@tanstack/react-router';

import { FamilyHubShell } from '~features/family-hub/ui/family-hub-shell';

const Component = () => {
  const { familyId } = Route.useParams();
  return <FamilyHubShell familyId={familyId} />;
};

export const Route = createFileRoute('/_auth/_layout/families/$familyId')({
  component: Component,
});
